module.exports = __webpack_public_path__ + "static/img/alpaga-05.1e603da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alpaga-05.png
// module id = 64
// module chunks = 0